module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Mystic.9e180882.jpg";